import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Select } from 'antd';
import LazyLoadSelect from "./LazyLoadSelect";
import { nonEmpty } from "../../../swzutils";
export default function AdminUserSelect({ value, disabled = false, allowClear = false, tenantId, placeholder = "Select a user", style, onChange, salesAdminUserEnabled = false }) {
    const optionsRenderer = (users) => {
        return users.map(user => {
            const optionText = nonEmpty `${user.firstName} ${user.lastName}`;
            return _jsx(Select.Option, { value: user.id, filter: optionText, children: optionText }, user.id);
        });
    };
    return (_jsx(LazyLoadSelect, { url: "/admin/v1/users", searchKey: "nameLike", queryParams: {
            userType: 'ADMIN',
            statuses: 'ENABLED',
            salesAdminUserEnabled
        }, disabled: disabled, tenantId: tenantId, allowClear: allowClear, placeholder: placeholder, notFoundMessage: salesAdminUserEnabled ? "No sales people found" : "No users found", style: style, onChange: onChange, value: value, optionsRenderer: optionsRenderer }));
}
